import React, { useEffect, useState, useCallback } from "react";
import Map, { Marker, NavigationControl, Source, Layer } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import useLocation from "../../../../hooks/useLocation";
import { navigation } from "../../../../services/rest/mapbox/navigationMap";
import toast from "react-hot-toast";
import PlaceIcon from "@mui/icons-material/Place";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";

const MapPreview = ({ coordinates = [], setLoading }) => {
  const { viewport, setViewport, userLocation } = useLocation();
  const [completeRoute, setCompleteRoute] = useState(null);
  const mapRef = React.useRef();

  // Centrar el mapa en el primer punto de la ruta o en la ubicación del usuario
  const centerMap = useCallback(() => {
    if (!mapRef.current) return;

    // Si hay ruta, centrar en el primer punto
    if (completeRoute && completeRoute.length >= 2) {
      mapRef.current.flyTo({
        center: [completeRoute[0][0], completeRoute[0][1]],
        zoom: 17,
        duration: 1000,
      });
    }
    // Si no hay ruta pero sí ubicación del usuario
    else if (userLocation) {
      mapRef.current.flyTo({
        center: [userLocation.longitude, userLocation.latitude],
        zoom: 14,
        duration: 1000,
      });
    }
  }, [completeRoute, userLocation]);

  useEffect(() => {
    const getAllRoute = async () => {
      try {
        setLoading(true);
        const coordinatesString = coordinates
          .map((coord) => coord.join(","))
          .join(";");
        const responseMapbox = await navigation(coordinatesString);
        setCompleteRoute(responseMapbox?.geometry?.coordinates ?? null);
      } catch (error) {
        toast.error("No se pudo obtener la ruta. Inténtalo más tarde.");
      } finally {
        setLoading(false);
      }
    };

    if (coordinates.length >= 2) {
      getAllRoute();
    } else {
      setCompleteRoute(null);
    }
  }, [coordinates]);

  // Ajustar la vista cuando cambian los datos
  useEffect(() => {
    centerMap();
  }, [completeRoute, userLocation, centerMap]);

  const routeLine = {
    type: "Feature",
    properties: {},
    geometry: {
      type: "LineString",
      coordinates: completeRoute || [],
    },
  };

  return (
    <Map
      {...viewport}
      ref={mapRef}
      mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
      onMove={(evt) => setViewport(evt.viewState)}
      mapStyle="mapbox://styles/mapbox/streets-v11"
    >
      <NavigationControl position="top-right" />

      {/* Línea de la ruta */}
      {completeRoute && completeRoute.length >= 2 && (
        <Source id="route" type="geojson" data={routeLine}>
          <Layer
            id="route"
            type="line"
            source="route"
            layout={{
              "line-join": "round",
              "line-cap": "round",
            }}
            paint={{
              "line-color": "black",
              "line-width": 10,
              "line-opacity": 0.8,
            }}
          />
        </Source>
      )}

      {/* Marcadores */}
      {completeRoute &&
        completeRoute.map((coord, index) => {
          if (index === 0 || index === completeRoute.length - 1) {
            return (
              <Marker
                key={`marker-${index}`}
                longitude={coord[0]}
                latitude={coord[1]}
              >
                <div
                  style={{
                    position: "relative",
                    transform: "translateY(-50%)",
                    filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.9))",
                  }}
                >
                  {index === completeRoute.length - 1 && (
                    <PlaceIcon
                      style={{
                        color: "red",
                        fontSize: 40,
                        transform: "scale(1.2)",
                      }}
                    />
                  )}
                  {index === 0 && (
                    <DirectionsRunIcon
                      style={{
                        color: "red",
                        fontSize: 40,
                        transform: "scale(1.2)",
                      }}
                    />
                  )}
                </div>
              </Marker>
            );
          }
        })}

      {/* Marcador de usuario cuando no hay ruta */}
      {!completeRoute && userLocation && (
        <Marker
          longitude={userLocation.longitude}
          latitude={userLocation.latitude}
        >
          <PlaceIcon style={{ color: "#3b82f6", fontSize: 30 }} />
        </Marker>
      )}
    </Map>
  );
};

export default MapPreview;

// import React, { useEffect, useState } from "react";
// import Map, { Marker, NavigationControl, Source, Layer } from "react-map-gl";
// import "mapbox-gl/dist/mapbox-gl.css";
// import useLocation from "../../../../hooks/useLocation";
// import { navigation } from "../../../../services/rest/mapbox/navigationMap";
// import toast from "react-hot-toast";
// import PlaceIcon from "@mui/icons-material/Place";
// import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";

// const MapPreview = ({ coordinates = [], setLoading }) => {
//   const { viewport, setViewport } = useLocation();
//   const [completeRoute, setCompleteRoute] = useState(null); // Inicializado como null

//   useEffect(() => {
//     const getAllRoute = async () => {
//       try {
//         setLoading(true);
//         const coordinatesString = coordinates
//           .map((coord) => coord.join(","))
//           .join(";");
//         const responseMapbox = await navigation(coordinatesString);
//         setCompleteRoute(responseMapbox ?? null);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         toast.error(
//           "En este momento no se pudo obtener tu ruta. \n Inténtalo más tarde."
//         );
//       }
//     };

//     if (coordinates.length >= 2) {
//       // Necesitas al menos 2 puntos para una línea
//       getAllRoute();
//     }
//   }, [coordinates]);

//   // Crear el objeto GeoJSON correctamente
//   const routeLine = {
//     type: "Feature",
//     properties: {},
//     geometry: {
//       type: "LineString",
//       coordinates: completeRoute || [], // Usa un array vacío si completeRoute es null
//     },
//   };

//   return (
//     <Map
//       {...viewport}
//       mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
//       onMove={(evt) => setViewport(evt.viewState)}
//       mapStyle="mapbox://styles/mapbox/streets-v11"
//     >
//       <NavigationControl position="top-right" />

//       {/* Renderiza la línea SOLO si hay datos válidos */}
//       {completeRoute && completeRoute.length >= 2 && (
//         <Source id="route" type="geojson" data={routeLine}>
//           <Layer
//             id="route"
//             type="line"
//             source="route"
//             layout={{
//               "line-join": "round",
//               "line-cap": "round",
//             }}
//             paint={{
//               "line-color": "black",
//               "line-width": 10,
//               "line-opacity": 0.8,
//             }}
//           />
//         </Source>
//       )}

//       {/* Marcadores (solo si hay coordenadas) */}
//       {completeRoute &&
//         completeRoute.map((coord, index) => {
//           if (index === 0 || index === completeRoute.length - 1) {
//             return (
//               <Marker
//                 key={`marker-${index}`}
//                 longitude={coord[0]}
//                 latitude={coord[1]}
//               >
//                 <div
//                   style={{
//                     position: "relative",
//                     transform: "translateY(-50%)",
//                     filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.9))",
//                   }}
//                 >
//                   {index === completeRoute.length - 1 && (
//                     <PlaceIcon
//                       style={{
//                         color: "red",
//                         fontSize: 40,
//                         transform: "scale(1.2)",
//                       }}
//                     />
//                   )}
//                   {index === 0 && (
//                     <DirectionsRunIcon
//                       style={{
//                         color: "red",
//                         fontSize: 40,
//                         transform: "scale(1.2)",
//                       }}
//                     />
//                   )}
//                 </div>
//               </Marker>
//             );
//           }
//         })}
//     </Map>
//   );
// };

// export default MapPreview;
